import configuration from "@intlayer/config/built";
import { fetcher } from "../fetcher.mjs";
const getOrganizationAPI = (authAPIOptions = {}, intlayerConfig) => {
  const backendURL = intlayerConfig?.editor?.backendURL ?? configuration.editor?.backendURL;
  if (!backendURL) {
    throw new Error(
      "Backend URL is not defined in the Intlayer configuration--."
    );
  }
  const ORGANIZATION_API_ROUTE = `${backendURL}/api/organization`;
  const getOrganizations = async (filters, otherOptions = {}) => await fetcher(
    ORGANIZATION_API_ROUTE,
    authAPIOptions,
    otherOptions,
    {
      params: filters
    }
  );
  const getOrganization = async (organizationId, otherOptions = {}) => await fetcher(
    `${ORGANIZATION_API_ROUTE}/${String(organizationId)}`,
    authAPIOptions,
    otherOptions
  );
  const addOrganization = async (organization, otherOptions = {}) => await fetcher(
    ORGANIZATION_API_ROUTE,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body: organization
    }
  );
  const updateOrganization = async (organization, otherOptions = {}) => fetcher(
    ORGANIZATION_API_ROUTE,
    authAPIOptions,
    otherOptions,
    {
      method: "PUT",
      body: organization
    }
  );
  const updateOrganizationMembers = async (body, otherOptions = {}) => fetcher(
    `${ORGANIZATION_API_ROUTE}/members`,
    authAPIOptions,
    otherOptions,
    {
      method: "PUT",
      body
    }
  );
  const addOrganizationMember = async (body, otherOptions = {}) => fetcher(
    `${ORGANIZATION_API_ROUTE}/member`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST",
      body
    }
  );
  const deleteOrganization = async (otherOptions = {}) => await fetcher(
    ORGANIZATION_API_ROUTE,
    authAPIOptions,
    otherOptions,
    {
      method: "DELETE"
    }
  );
  const selectOrganization = async (organizationId, otherOptions = {}) => await fetcher(
    `${ORGANIZATION_API_ROUTE}/${String(organizationId)}`,
    authAPIOptions,
    otherOptions,
    {
      method: "PUT"
    }
  );
  const unselectOrganization = async (otherOptions = {}) => await fetcher(
    `${ORGANIZATION_API_ROUTE}/logout`,
    authAPIOptions,
    otherOptions,
    {
      method: "POST"
    }
  );
  return {
    getOrganizations,
    getOrganization,
    addOrganization,
    addOrganizationMember,
    updateOrganization,
    updateOrganizationMembers,
    deleteOrganization,
    selectOrganization,
    unselectOrganization
  };
};
export {
  getOrganizationAPI
};
//# sourceMappingURL=organization.mjs.map